import _isEqual from "lodash/isEqual";
import _cloneDeep from "lodash/cloneDeep";

export class VacancyParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(Vacancy.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    index >=0 && this.list.splice(index, 1, Vacancy.build(item))
  }

  removeVacancy(item) {
    const index = this.list.findIndex(el => _isEqual(_cloneDeep(el), _cloneDeep(item)) || el.id === item.id)
    index >=0 && this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => Vacancy.build(el))
    }
    return this
  }
}

export class Vacancy {
  constructor() {
    this.id = null
    this.courseNumber = null
    this.speciality = null
    this.paidForm = null
    this.quantity = null
    this.applicationCount = null
    this.vacancyStatus = null
  }

  getForAPI() {
    return {
      id: this.id,
      courseNumber: this.courseNumber,
      speciality: this.speciality,
      paidForm: this.paidForm,
      quantity: this.quantity,
      applicationCount: this.applicationCount,
      vacancyStatus: this.vacancyStatus,
    }
  }

  static build(obj) {
    const _this = new Vacancy()
    if (obj) {
      _this.id = obj.id
      _this.courseNumber = obj.courseNumber
      _this.speciality = obj.speciality
      _this.paidForm = obj.paidForm
      _this.quantity = obj.quantity
      _this.applicationCount = obj.applicationCount
      _this.vacancyStatus = obj.vacancyStatus
    }
    return _this
  }
}

export class VacancyFilter {
  constructor() {
    this.courseNumber = null
    this.speciality = null
    this.paidForm = null
  }
}
